import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectIsLoading } from "redux-toolkit/surveys/selectors";
import { updateSurveyAsync } from "redux-toolkit/surveys/actions";

const useSurveyVotes = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectIsLoading);

  const handleVote = useCallback(
    (id, currentUserId, state) => {
      const data = {
        [`votes.${currentUserId}`]: state,
      };
      dispatch(
        updateSurveyAsync({
          id,
          data,
        }),
      );
    },
    [dispatch],
  );

  return {
    isLoading,
    handleVote,
  };
};

export default useSurveyVotes;
